export default "__VITE_ASSET__COaejbNJ__"